import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { useAtom } from 'jotai';
import { payPlusSessionAtom } from 'Atoms/Ticket';
import { useHistory } from 'react-router-dom';
import './styles.css';
import { PAYPLUS_URL } from 'config';
import { PayPlusComponent } from '@web/payplus-component';

const PayPlusForm = ({
  setPayPlusValidationForm,
  loader,
  setOnFieldEdit,
  onFieldEdit,
  setConfirmationPaid,
  setErrorPaid,
  setLoader,
  payPlusValidationForm,
  setNewPayPlusToken,
  setInstance,
}) => {
  const history = useHistory();
  const [payPlusSession] = useAtom(payPlusSessionAtom);
  const { session, token, idTransaction } = payPlusSession || {};
  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (reset) {
      history.go(0);
    }
  });

  const callback = (instance) => {
    let validationForm = false;
    setInstance(instance);

    instance.do({
      action: 'pay',
      session: session,
      token: token,
      callback: function (success) {
        setConfirmationPaid(success);
        if (!success) {
          setPayPlusValidationForm(false);
          if (!!validationForm) {
            setErrorPaid(true);
            setNewPayPlusToken(false);
          }
          setLoader(false);
          setReset();
        }
      },
      onchange: function (valid) {
        setPayPlusValidationForm(valid);
        setOnFieldEdit(false);
        validationForm = valid;
      },
      onFieldEdit: function () {
        if (!onFieldEdit) setOnFieldEdit(true);
      },
    });
  };

  return (
    <>
      <PayPlusComponent
        id="laddpayplus"
        settings={{
          url: PAYPLUS_URL,
          methods: ['card', 'conecs', 'applepay'],
        }}
        callback={callback}
      />
    </>
  );
};

PayPlusForm.propTypes = {
  setPayPlusValidationForm: PropTypes.func.isRequired,
  setOnFieldEdit: PropTypes.func.isRequired,
  onFieldEdit: PropTypes.bool,
  setConfirmationPaid: PropTypes.func.isRequired,
  setErrorPaid: PropTypes.func.isRequired,
};

export default PayPlusForm;
